export default "__VITE_ASSET__724b2265__"